import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import "./scss/custom.scss";
import "./style.css";
import * as serviceWorker from "./serviceWorker";
import B2CWrapper from "./B2CWrapper";
import B2BWrapper from "./B2BWrapper";
import Auth0Wrapper from "./Auth0Wrapper";
import BasicAuthWrapper from "./BasicAuthWrapper";
import * as authTypes from "./constants/authTypes";
import AnonymousAuthWrapper from "./AnonymousAuthWrapper";

const { REACT_APP_AUTH } = process.env;

const getAuthWrapper = () => {
  switch (REACT_APP_AUTH) {
    case authTypes.B2B:
      return B2BWrapper;
    case authTypes.B2C:
      return B2CWrapper;
    case authTypes.AUTH0:
      return Auth0Wrapper;
    case authTypes.BASIC:
      return BasicAuthWrapper;
    case authTypes.ANONYMOUS:
      return AnonymousAuthWrapper;
    default:
      return B2CWrapper;
  }
};

const AuthWrapper = getAuthWrapper();

const root = ReactDOM.createRoot(document.getElementById("root") || document.createElement("div"));
root.render(
  <React.StrictMode>
    <AuthWrapper>
      <App />
    </AuthWrapper>
  </React.StrictMode>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
